import { Input } from "antd";
import type { Rule } from "antd/es/form";
import { useTranslation } from "react-i18next";
import { PASSWORD_MESSAGES, passwordIssues, passwordStrength } from "@audit-plan/shared";
import { palette } from "../theme";

const COLORS = ["#d9d9d9", palette.bad, palette.warn, palette.ok, palette.ok];

/** Regola antd per i Form.Item della password: stesse regole del server (lunghezza, tre tipi su quattro, diversa dall'email). */
export function usePasswordRules(email = ""): Rule[] {
  const { t, i18n } = useTranslation();
  const m = PASSWORD_MESSAGES[i18n.language === "en" ? "en" : "it"];
  return [
    { required: true, message: t("required") },
    {
      validator: (_, v: string) => {
        const issues = v ? passwordIssues(v, email) : [];
        return issues.length ? Promise.reject(new Error(issues.map((i) => m[i]).join(". "))) : Promise.resolve();
      },
    },
  ];
}

/** Input password con indicatore di robustezza (orientativo: il server applica anche l'elenco delle password comuni). */
export function PasswordField(props: { value?: string; onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void; email?: string; autoComplete?: string; autoFocus?: boolean; size?: "large" | "middle" }) {
  const { t } = useTranslation();
  const { value = "", onChange, email, autoComplete = "new-password", autoFocus, size = "large" } = props;
  const s = passwordStrength(value, email);
  return (
    <div>
      <Input.Password value={value} onChange={onChange} autoComplete={autoComplete} autoFocus={autoFocus} size={size} style={{ fontSize: 16 }} />
      <div aria-live="polite" style={{ marginTop: 6 }}>
        <div style={{ display: "flex", gap: 4 }}>
          {[1, 2, 3, 4].map((i) => (
            <div key={i} style={{ flex: 1, height: 4, borderRadius: 2, background: value && i <= s ? COLORS[s] : palette.hair }} />
          ))}
        </div>
        <div style={{ fontSize: 12, color: palette.muted, marginTop: 4, minHeight: 18 }}>{value ? t(`c_pwdStrength_${s}`) : t("c_pwdRules")}</div>
      </div>
    </div>
  );
}
